<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl, Map } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { useMapBox } from './composables/useMapBox'

const props = defineProps<{
	position?: ControlPosition
}>()

let control: IControl | undefined

const fullscreenButton = ref<HTMLElement>()
const isFullscreen = ref(false)

const { map } = useMapBox()

function toggleFullscreen() {
	const container = map?.value?.getContainer()?.parentElement
	if (!container) return

	if (!document.fullscreenElement) {
		container.requestFullscreen()
	} else {
		document.exitFullscreen()
	}
}

function onFullscreenChange() {
	isFullscreen.value = !!document.fullscreenElement
}

onMounted(() => {
	document.addEventListener('fullscreenchange', onFullscreenChange)

	let container: HTMLDivElement

	control = {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		onAdd(_map: Map) {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			fullscreenButton.value?.addEventListener('click', toggleFullscreen)

			container.appendChild(fullscreenButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	map?.value?.addControl(control!, props.position || 'top-right')
})

onUnmounted(() => {
	document.removeEventListener('fullscreenchange', onFullscreenChange)
	if (control) map?.value?.removeControl(control)
})
</script>

<template>
	<div>
		<button
			style="border: 1px solid #737576"
			class="flex items-center justify-center w-8 h-8 rounded-md bg-white-neutral border border-gray-medium"
			ref="fullscreenButton"
		>
			<Icon
				class="text-xl"
				:icon="isFullscreen ? 'material-symbols:zoom-in-map' : 'material-symbols:zoom-out-map'"
			/>
		</button>
	</div>
</template>

<style>
.mapboxgl-ctrl button:hover {
	background-color: #fefefe !important;
	opacity: 0.95;
}
</style>
